(function () {
  if (window.__rhlCardQuickAddReady) return;
  window.__rhlCardQuickAddReady = true;

  const cartRoot = window.Shopify?.routes?.root || '/';
  const products = new Map();
  let cartQueue = Promise.resolve();
  function runCartMutation(work) {
    if (window.RHLCartSync) return window.RHLCartSync.run(work);
    const pending = cartQueue.then(work);
    cartQueue = pending.catch(() => {});
    return pending;
  }
  const cartSection = () => document.querySelector('[ref="hdt-cart"]')?.getAttribute('section-id') || '';
  const cardsForVariant = (variantId) => Array.from(document.querySelectorAll('[data-rhl-card-atc]'))
    .filter((card) => card.dataset.variantId === String(variantId));

  // Show confirmations only after a successful cart mutation.
  let feedbackNode;
  let feedbackTimer;
  function hideAddedFeedback() {
    clearTimeout(feedbackTimer);
    if (feedbackNode) feedbackNode.hidden = true;
  }
  function scheduleFeedbackDismiss() {
    clearTimeout(feedbackTimer);
    if (feedbackNode?.dataset.place === 'toast' && !feedbackNode.matches(':hover, :focus-within')) {
      feedbackTimer = setTimeout(hideAddedFeedback, 8000);
    }
  }
  function placeAddedFeedback(inOptions) {
    if (!feedbackNode || feedbackNode.hidden) return;
    const cartDialog = document.querySelector('#CartDrawer[open]');
    const header = inOptions ? drawer?.querySelector('.rhl-choose-header') : cartDialog?.querySelector('.hdt-dialog-drawer__header');
    feedbackNode.dataset.place = inOptions ? 'options' : header ? 'cart' : 'toast';
    feedbackNode.classList.toggle('rhl-add-feedback--toast', !header);
    feedbackNode.querySelector('[data-rhl-feedback-view]').hidden = feedbackNode.dataset.place === 'cart';
    if (header) header.after(feedbackNode);
    else document.body.appendChild(feedbackNode);
    scheduleFeedbackDismiss();
  }
  function showAddedFeedback(selection, inOptions = false) {
    if (!feedbackNode) {
      feedbackNode = document.createElement('aside');
      feedbackNode.className = 'rhl-add-feedback';
      feedbackNode.innerHTML = `
        <span class="rhl-add-feedback__check" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none"><path d="m6 12 4 4 8-8" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg></span>
        <div class="rhl-add-feedback__copy" role="status" aria-live="polite" aria-atomic="true">
          <strong>Added to your enquiry list</strong>
          <p data-rhl-feedback-product></p>
          <small data-rhl-feedback-options></small>
        </div>
        <button class="rhl-add-feedback__dismiss" type="button" aria-label="Dismiss confirmation"><svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="m5 5 10 10M15 5 5 15" stroke="currentColor" stroke-width="1.4"/></svg></button>
        <button class="rhl-add-feedback__view" data-rhl-feedback-view type="button">View enquiry <span aria-hidden="true">→</span></button>`;
      feedbackNode.querySelector('.rhl-add-feedback__dismiss').addEventListener('click', hideAddedFeedback);
      feedbackNode.querySelector('[data-rhl-feedback-view]').addEventListener('click', () => {
        clearTimeout(feedbackTimer);
        const wasInOptions = feedbackNode.dataset.place === 'options';
        if (wasInOptions) closeDrawer();
        feedbackNode.dataset.place = 'cart';
        setTimeout(() => {
          const cart = document.querySelector('[ref="hdt-cart"]');
          if (typeof cart?.open === 'function') {
            cart.open();
            placeAddedFeedback(false);
          } else window.location.assign(`${cartRoot}cart`);
        }, wasInOptions ? 280 : 0);
      });
      ['mouseenter', 'focusin'].forEach((name) => feedbackNode.addEventListener(name, () => clearTimeout(feedbackTimer)));
      ['mouseleave', 'focusout'].forEach((name) => feedbackNode.addEventListener(name, () => setTimeout(scheduleFeedbackDismiss, 0)));
    }
    const amount = Math.max(1, Number(selection.quantity) || 1);
    feedbackNode.querySelector('[data-rhl-feedback-product]').textContent = selection.title ? `${amount} × ${selection.title}` : `${amount} ${amount === 1 ? 'item' : 'items'} added`;
    const options = feedbackNode.querySelector('[data-rhl-feedback-options]');
    options.textContent = selection.options || '';
    options.hidden = !selection.options;
    feedbackNode.hidden = false;
    placeAddedFeedback(inOptions);
  }
  function listenForNativeAdds() {
    document.addEventListener('cart:update', (event) => {
      const detail = event.detail;
      const added = detail?.rhlAdded || detail?.cartData;
      if (detail?.source !== 'product-form-component' || !added || added.status || added.errors) return;
      if (!added.id && !added.variant_id && !added.items?.length) return;
      const items = added.items || [added];
      const first = items[0];
      const selection = {
        title: items.length > 1 ? 'selected products' : first.product_title || first.title || '',
        quantity: Number(detail.data?.itemCount) || 1,
        options: items.length === 1 && first.variant_title !== 'Default Title' ? first.variant_title || '' : ''
      };
      setTimeout(() => showAddedFeedback(selection), 0);
    });
    ['dialog:opening', 'dialog:open'].forEach((name) => document.addEventListener(name, () => {
      if (feedbackNode && !feedbackNode.hidden && feedbackNode.dataset.place !== 'options') {
        requestAnimationFrame(() => placeAddedFeedback(false));
      }
    }));
    document.addEventListener('cart:error', hideAddedFeedback);
  }

  function setCardState(card, quantity, lineKey) {
    card.dataset.quantity = String(quantity);
    if (lineKey) card.dataset.lineKey = lineKey;
    else delete card.dataset.lineKey;
    const addButton = card.querySelector('[data-rhl-card-add]');
    const quantityControl = card.querySelector('[data-rhl-card-quantity]');
    const output = card.querySelector('[data-rhl-card-value]');
    const compactCard = window.matchMedia('(hover: none), (max-width: 767px)').matches;
    if (output) output.value = output.textContent = String(quantity);
    if (addButton) addButton.hidden = !compactCard && quantity > 0;
    if (quantityControl) quantityControl.hidden = compactCard || quantity < 1;
  }

  function setBusy(variantId, busy) {
    cardsForVariant(variantId).forEach((card) => {
      card.dataset.busy = busy ? 'true' : 'false';
      card.querySelectorAll('button').forEach((button) => {
        button.disabled = busy || (button.matches('[data-rhl-card-add]') && card.dataset.purchasable !== 'true');
      });
    });
  }

  function showError(card, message) {
    const status = card.querySelector('[data-rhl-card-status]');
    const addButton = card.querySelector('[data-rhl-card-add]');
    if (status) status.textContent = message || '';
    if (addButton) {
      if (message) addButton.setAttribute('title', message);
      else addButton.removeAttribute('title');
    }
  }

  async function postJSON(path, body) {
    const response = await fetch(`${cartRoot}${path}`, {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    const data = await response.json();
    if (!response.ok || data.status || data.errors) {
      throw new Error(data.description || data.message || data.errors || 'Could not update the cart. Please try again.');
    }
    return data;
  }

  async function dispatchCartUpdate(card, cartData, source, actionAfterATC) {
    if (window.RHLCartSync) {
      const expected = Number.isInteger(cartData?.item_count) ? null : (cartData?.items || (cartData?.id ? [cartData] : null));
      return window.RHLCartSync.sync({ source, actionAfterATC, sourceId: String(card.dataset.variantId), rhlExpectedItems: expected });
    }
    const sectionId = cartSection();
    if (!sectionId || !cartData?.sections?.[sectionId]) {
      document.dispatchEvent(new CustomEvent('cart:reload', { bubbles: true }));
      return;
    }
    card.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: {},
        sourceId: String(card.dataset.variantId),
        cartData,
        actionAfterATC,
        source,
        data: {
          itemCount: Number(card.dataset.quantity) || 0,
          productId: card.dataset.productId,
          variantId: String(card.dataset.variantId),
          sections: cartData.sections,
        },
      },
    }));
  }

  function getProduct(handle) {
    if (products.has(handle)) return products.get(handle);
    const request = fetch(`${cartRoot}products/${encodeURIComponent(handle)}.js`, {
      headers: { Accept: 'application/json' },
      cache: 'force-cache',
    }).then((response) => {
      if (!response.ok) throw new Error('Product options could not be loaded. Please try again.');
      return response.json();
    }).catch((error) => {
      products.delete(handle);
      throw error;
    });
    products.set(handle, request);
    return request;
  }

  function getRule(card, variantId) {
    try {
      return JSON.parse(card.dataset.variantRules || '[]').find((rule) => String(rule.id) === String(variantId)) || {};
    } catch (_) {
      return {};
    }
  }

  function formatMoney(cents) {
    const currency = window.Shopify?.currency?.active || 'USD';
    const locale = document.documentElement.lang || 'en-US';
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(Number(cents || 0) / 100);
    } catch (_) {
      return `$${(Number(cents || 0) / 100).toFixed(2)}`;
    }
  }

  function variantImage(variant, product) {
    const image = variant?.featured_image || product.featured_image || product.images?.[0] || '';
    const src = typeof image === 'string' ? image : (image?.src || '');
    if (!src) return '';
    // The options drawer shows a 114px thumbnail; avoid downloading the full-size original.
    try {
      const url = new URL(src, window.location.origin);
      if (url.hostname === 'cdn.shopify.com' || url.pathname.startsWith('/cdn/shop/')) {
        url.searchParams.set('width', '360');
      }
      return url.href;
    } catch (_) { return src; }
  }

  let drawer;
  let activeCard;
  let activeProduct;
  let selectedOptions = [];
  let selectedVariant;
  let selectedQuantity = 1;
  let activeRule = {};
  let lastFocused;

  function ensureDrawer() {
    if (drawer) return drawer;
    drawer = document.createElement('div');
    drawer.className = 'rhl-choose-overlay';
    drawer.hidden = true;
    drawer.innerHTML = `
      <section class="rhl-choose-drawer" role="dialog" aria-modal="true" aria-labelledby="rhl-choose-title" tabindex="-1">
        <header class="rhl-choose-header">
          <h2 id="rhl-choose-title">CHOOSE OPTIONS</h2>
          <button class="rhl-choose-close" type="button" data-rhl-choose-close aria-label="Close options">&times;</button>
        </header>
        <div class="rhl-choose-content">
          <div class="rhl-choose-product">
            <img class="rhl-choose-image" data-rhl-choose-image alt="" loading="lazy">
            <div class="rhl-choose-product-copy">
              <p class="rhl-choose-product-title" data-rhl-choose-product-title></p>
              <p class="rhl-choose-price"><span data-rhl-choose-price></span><s data-rhl-choose-compare hidden></s></p>
              <a class="rhl-choose-details" data-rhl-choose-details hidden>View details</a>
            </div>
          </div>
          <div class="rhl-choose-options" data-rhl-choose-options></div>
          <p class="rhl-choose-error" data-rhl-choose-error role="status" aria-live="polite"></p>
        </div>
        <footer class="rhl-choose-footer">
          <div class="rhl-choose-quantity-row">
            <span>Quantity</span>
            <div class="rhl-choose-quantity">
              <button type="button" data-rhl-choose-qty="minus" aria-label="Decrease quantity">−</button>
              <output data-rhl-choose-quantity>1</output>
              <button type="button" data-rhl-choose-qty="plus" aria-label="Increase quantity">+</button>
            </div>
          </div>
          <button class="rhl-choose-submit" type="button" data-rhl-choose-submit>Add to cart</button>
        </footer>
      </section>`;
    document.body.appendChild(drawer);
    drawer.addEventListener('click', onDrawerClick);
    document.addEventListener('keydown', (event) => {
      if (!drawer.hidden && event.key === 'Escape') closeDrawer();
      if (!drawer.hidden && event.key === 'Tab') trapFocus(event);
    });
    return drawer;
  }

  function openDrawer() {
    const root = ensureDrawer();
    lastFocused = document.activeElement;
    root.hidden = false;
    document.documentElement.classList.add('rhl-choose-open');
    requestAnimationFrame(() => {
      root.classList.add('is-open');
      root.querySelector('.rhl-choose-drawer')?.focus({ preventScroll: true });
    });
  }

  function closeDrawer() {
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('rhl-choose-open');
    window.setTimeout(() => {
      if (!drawer.classList.contains('is-open')) drawer.hidden = true;
    }, 260);
    if (lastFocused?.isConnected) lastFocused.focus({ preventScroll: true });
  }

  function trapFocus(event) {
    const focusable = Array.from(drawer.querySelectorAll('button:not([disabled]), [href], input:not([disabled]), [tabindex]:not([tabindex="-1"])'))
      .filter((element) => !element.hidden && element.getClientRects().length > 0);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function openOptions(card) {
    hideAddedFeedback();
    activeCard = card;
    const root = ensureDrawer();
    root.querySelector('[data-rhl-choose-product-title]').textContent = card.dataset.productTitle || '';
    root.querySelector('[data-rhl-choose-options]').innerHTML = '<p class="rhl-choose-loading">Loading options…</p>';
    root.querySelector('[data-rhl-choose-error]').textContent = '';
    root.querySelector('[data-rhl-choose-submit]').disabled = true;
    root.querySelector('[data-rhl-choose-image]').removeAttribute('src');
    root.querySelector('[data-rhl-choose-price]').textContent = '';
    root.querySelector('[data-rhl-choose-compare]').hidden = true;
    root.querySelector('[data-rhl-choose-quantity]').textContent = '1';
    const details = root.querySelector('[data-rhl-choose-details]');
    const handle = card.dataset.handle || '';
    details.hidden = !handle;
    if (handle) details.href = `${cartRoot}products/${encodeURIComponent(handle)}`;
    openDrawer();

    return getProduct(card.dataset.handle).then((product) => {
      activeProduct = product;
      const initialId = card.dataset.variantId || card.dataset.initialVariant;
      selectedVariant = product.variants.find((variant) => String(variant.id) === String(initialId) && variant.available)
        || product.variants.find((variant) => variant.available)
        || product.variants[0];
      selectedOptions = [...(selectedVariant?.options || [])];
      activeRule = getRule(card, selectedVariant?.id);
      const minimum = Math.max(1, Number(activeRule.min) || 1);
      selectedQuantity = minimum;
      root.querySelector('[data-rhl-choose-image]').src = variantImage(selectedVariant, product);
      root.querySelector('[data-rhl-choose-image]').alt = product.title || '';
      renderOptions();
    }).catch((error) => {
      root.querySelector('[data-rhl-choose-options]').innerHTML = '';
      root.querySelector('[data-rhl-choose-error]').textContent = error.message;
    });
  }

  function renderOptions() {
    if (feedbackNode?.dataset.place === 'options') hideAddedFeedback();
    const root = ensureDrawer();
    const groups = root.querySelector('[data-rhl-choose-options]');
    groups.innerHTML = '';
    (activeProduct.options || []).forEach((option, optionIndex) => {
      const optionName = typeof option === 'string' ? option : (option?.name || option?.label || `Option ${optionIndex + 1}`);
      const values = [...new Set(activeProduct.variants.map((variant) => variant.options?.[optionIndex]).filter(Boolean))];
      if (values.length === 1 && values[0] === 'Default Title') return;
      const group = document.createElement('fieldset');
      group.className = 'rhl-choose-group';
      const legend = document.createElement('legend');
      legend.textContent = selectedOptions[optionIndex]
        ? `${optionName}: ${selectedOptions[optionIndex]}`
        : optionName;
      group.appendChild(legend);
      const choices = document.createElement('div');
      choices.className = 'rhl-choose-values';
      values.forEach((value) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'rhl-choose-value';
        button.dataset.rhlOptionIndex = String(optionIndex);
        button.dataset.rhlOptionValue = value;
        button.setAttribute('aria-pressed', String(selectedOptions[optionIndex] === value));
        button.disabled = !activeProduct.variants.some((variant) =>
          variant.available && variant.options?.[optionIndex] === value
        );
        button.textContent = value;
        choices.appendChild(button);
      });
      group.appendChild(choices);
      groups.appendChild(group);
    });

    selectedVariant = activeProduct.variants.find((variant) => (variant.options || []).every((value, index) => value === selectedOptions[index]));
    const price = root.querySelector('[data-rhl-choose-price]');
    const compare = root.querySelector('[data-rhl-choose-compare]');
    const image = root.querySelector('[data-rhl-choose-image]');
    if (selectedVariant) {
      price.textContent = formatMoney(selectedVariant.price);
      compare.hidden = !(selectedVariant.compare_at_price > selectedVariant.price);
      compare.textContent = compare.hidden ? '' : formatMoney(selectedVariant.compare_at_price);
      image.src = variantImage(selectedVariant, activeProduct);
      activeRule = getRule(activeCard, selectedVariant.id);
      const min = Math.max(1, Number(activeRule.min) || 1);
      const max = Number(activeRule.max);
      selectedQuantity = Math.max(min, selectedQuantity);
      if (Number.isFinite(max) && max > 0) selectedQuantity = Math.min(max, selectedQuantity);
      root.querySelector('[data-rhl-choose-quantity]').textContent = String(selectedQuantity);
    }
    const submit = root.querySelector('[data-rhl-choose-submit]');
    submit.disabled = !selectedVariant || !selectedVariant.available;
    submit.textContent = selectedVariant?.available ? 'Add to cart' : 'Sold out';
  }

  async function addSelectedVariant() {
    const root = ensureDrawer();
    if (!activeCard || !selectedVariant?.available || activeCard.dataset.busy === 'true') return;
    const card = activeCard;
    const variant = selectedVariant;
    const product = activeProduct;
    const amountAdded = selectedQuantity;
    hideAddedFeedback();
    const variantId = String(variant.id);
    const submit = root.querySelector('[data-rhl-choose-submit]');
    const error = root.querySelector('[data-rhl-choose-error]');
    error.textContent = '';
    submit.disabled = true;
    submit.textContent = 'Adding…';
    card.dataset.variantId = variantId;
    card.dataset.purchasable = 'true';
    card.dataset.min = String(Math.max(1, Number(activeRule.min) || 1));
    card.dataset.step = String(Math.max(1, Number(activeRule.step) || 1));
    if (activeRule.max != null) card.dataset.max = String(activeRule.max);
    else delete card.dataset.max;
    setBusy(variantId, true);
    try {
      await runCartMutation(async () => {
      const sectionId = cartSection();
      const body = new FormData();
      body.append('id', variantId);
      body.append('quantity', String(amountAdded));
      if (sectionId) body.append('sections', sectionId);
      const response = await fetch(`${cartRoot}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body,
      });
      const added = await response.json();
      if (!response.ok || added.status || added.errors) {
        throw new Error(added.description || added.message || added.errors || 'Could not add this item. Please try again.');
      }
      // Success is shown only after the coordinator verifies this exact
      // variant and quantity in Shopify, then updates the complete cart.
      // Never combine stale add-response HTML with a later cart snapshot.
      // The coordinator refreshes every card, header and drawer together.
      await dispatchCartUpdate(card, added, 'rhl-card-quick-add', 'no_action');
      });
      const sameSelection = activeCard === card && activeProduct === product && selectedVariant?.id === variant.id;
      showAddedFeedback({ title: product.title, quantity: amountAdded, options: (variant.options || []).filter((value) => value !== 'Default Title').join(' · ') }, sameSelection && !drawer.hidden);
      if (sameSelection) { submit.disabled = false; submit.textContent = 'Add another'; }
    } catch (exception) {
      console.error('[RHL quick add]', exception);
      showError(card, exception.message);
      if (activeCard === card && selectedVariant?.id === variant.id) {
        error.textContent = exception.message;
        submit.disabled = false;
        submit.textContent = 'Add to cart';
      }
    } finally {
      setBusy(variantId, false);
    }
  }

  function onDrawerClick(event) {
    const close = event.target.closest('[data-rhl-choose-close]');
    if (close || event.target === drawer) {
      closeDrawer();
      return;
    }
    const option = event.target.closest('[data-rhl-option-index]');
    if (option && activeProduct) {
      const optionIndex = Number(option.dataset.rhlOptionIndex);
      const optionValue = option.dataset.rhlOptionValue;
      const matchingVariant = activeProduct.variants.find((variant) =>
        variant.available && variant.options?.[optionIndex] === optionValue &&
        variant.options.every((value, index) => index === optionIndex || value === selectedOptions[index])
      ) || activeProduct.variants.find((variant) =>
        variant.available && variant.options?.[optionIndex] === optionValue
      );
      if (matchingVariant) selectedOptions = [...matchingVariant.options];
      else selectedOptions[optionIndex] = optionValue;
      renderOptions();
      return;
    }
    const quantityButton = event.target.closest('[data-rhl-choose-qty]');
    if (quantityButton) {
      const min = Math.max(1, Number(activeRule.min) || 1);
      const step = Math.max(1, Number(activeRule.step) || 1);
      const max = Number(activeRule.max);
      selectedQuantity = quantityButton.dataset.rhlChooseQty === 'plus'
        ? (Number.isFinite(max) && max > 0 ? Math.min(max, selectedQuantity + step) : selectedQuantity + step)
        : Math.max(min, selectedQuantity - step);
      drawer.querySelector('[data-rhl-choose-quantity]').textContent = String(selectedQuantity);
      return;
    }
    if (event.target.closest('[data-rhl-choose-submit]')) addSelectedVariant();
  }

  async function updateQuantity(card, nextQuantity) {
    const variantId = card.dataset.variantId;
    const lineKey = card.dataset.lineKey;
    const previousQuantity = Number(card.dataset.quantity) || 0;
    if (!lineKey) throw new Error('Refresh the page and try again.');
    const sectionId = cartSection();
    const payload = {
      id: lineKey,
      quantity: nextQuantity,
      sections: sectionId ? [sectionId] : [],
      sections_url: `${window.location.pathname}${window.location.search}`,
    };
    const cart = await postJSON('cart/change.js', payload);
    const line = cart.items.find((item) => item.key === lineKey);
    const quantity = Number(line?.quantity) || 0;
    cardsForVariant(variantId).forEach((item) => setCardState(item, quantity, line?.key || ''));
    await dispatchCartUpdate(card, cart, 'rhl-card-quick-add', 'no_action');
    if (quantity > previousQuantity) showAddedFeedback({ title: line?.product_title || card.dataset.productTitle, quantity: quantity - previousQuantity, options: line?.variant_title === 'Default Title' ? '' : line?.variant_title || '' });
  }

  listenForNativeAdds();
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-rhl-card-add], [data-rhl-card-increase], [data-rhl-card-decrease]');
    if (!button) return;
    const card = button.closest('[data-rhl-card-atc]');
    if (!card) return;

    event.preventDefault();
    event.stopPropagation();
    if (card.dataset.busy === 'true') return;

    const variantId = card.dataset.variantId;
    const current = Number(card.dataset.quantity) || 0;
    const min = Math.max(1, Number(card.dataset.min) || 1);
    const step = Math.max(1, Number(card.dataset.step) || 1);
    const max = Number(card.dataset.max);
    let next = current;
    if (button.matches('[data-rhl-card-add]')) {
      showError(card, '');
      if (current < 1 || !card.dataset.lineKey) {
        openOptions(card);
        return;
      }
      next = Number.isFinite(max) && max > 0 ? Math.min(max, current + step) : current + step;
      if (next === current) return;
    }
    else if (button.matches('[data-rhl-card-increase]')) next = Number.isFinite(max) && max > 0 ? Math.min(max, current + step) : current + step;
    else next = current <= min ? 0 : Math.max(min, current - step);

    setBusy(variantId, true);
    cardsForVariant(variantId).forEach((item) => showError(item, ''));
    try {
      if (next !== current) await runCartMutation(() => updateQuantity(card, next));
    } catch (error) {
      console.error('[RHL quick add]', error);
      cardsForVariant(variantId).forEach((item) => showError(item, error.message));
    } finally {
      setBusy(variantId, false);
    }
  }, true);
})();
